import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./state";
import { diagnosticsApi } from "services/streamingApi/diagnostics.api";

// slice
export const diagnosticsSlice = createSlice({
    name: "diagnostics",
    initialState,
    reducers: {
        resetLogItems: (state) => {
            state.diagnosticsData = {
                diagnosticsLogNodes: [],
                livestreamStartupFlowSteps: [],
            };
        },

        // session
        setSessionId: (
            state,
            action: PayloadAction<{
                sessionId: string;
            }>,
        ) => {
            state.sessionId = action.payload.sessionId;
        },
        resetSessionId: (state) => {
            state.sessionId = undefined;
        },
        setDuration: (state, action: PayloadAction<number>) => {
            state.duration = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            diagnosticsApi.endpoints.getStreamDiagnosticsForOperation
                .matchFulfilled,
            (state, action) => {
                state.diagnosticsData = action.payload;
            },
        );
    },
});

// exports
export const diagnosticsActions = diagnosticsSlice.actions;

export default diagnosticsSlice.reducer;
